
import React from "react";
import { Label } from "@/components/ui/label";
import NumericInput from "@/components/ui/NumericInput";
import { InfoIcon } from "lucide-react";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";
import { formatCurrency, parseCurrency } from "../../utils/formatters";

interface HousingPaymentInputProps {
  currentHousingPayment: number;
  onChange: (value: number) => void;
}

const HousingPaymentInput: React.FC<HousingPaymentInputProps> = ({ currentHousingPayment, onChange }) => {
  return (
    <div className="space-y-1">
      <div className="flex items-center">
        <Label htmlFor="currentHousingPayment">Current Monthly Housing Payment</Label>
        <TooltipProvider>
          <Tooltip>
            <TooltipTrigger asChild>
              <InfoIcon className="h-4 w-4 text-gray-400 ml-2" />
            </TooltipTrigger>
            <TooltipContent className="w-80 p-3">
              <p>Your current rent or mortgage payment. A similar new housing payment 
              can be a compensating factor for approval.</p>
            </TooltipContent>
          </Tooltip>
        </TooltipProvider>
      </div>
      <NumericInput
        id="currentHousingPayment"
        value={currentHousingPayment}
        onChange={onChange}
        min={0}
        formatValue={formatCurrency}
        parseValue={parseCurrency}
        prefix="$"
        inputClassName="w-full sm:w-48"
      />
    </div>
  );
};

export default HousingPaymentInput;
